// extracted by mini-css-extract-plugin
export default {"r_l":"_836b11f41e _77d958609d","t":"_75f282892d"};